import React from 'react';
import ProjectSources from "./projectSources";

export function ProjectTemplate({
  template,
  conf,
  user,
}) {
  switch (template) {
    case 'projectSources':
    case 'projectClients':
      return <ProjectSources user={user} conf={conf} />;
    default:
      return null;
  }
}
